import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Btnsearch from '../../atoms/btnsearch';
import { fireStore } from '../../../database/utils/firebase';
import * as S from './styles';

import Header from '../../molecules/Header';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import { useSearchPath } from '../../../hooks/useSeachPath';
import ChargeAdmin from '../../organisms/ChargeAdmin';

function AdminTransactions() {
  const [search, setSearch] = useState('');
  const searchPath = useSearchPath(search);

  const [transactionsList, setTransactionsList] = useState([]);
  useEffect(() => {
    fireStore
      .collection('transactions')
      .get()
      .then(async (response) => {
        const transactionPromises = response.docs.map(async (doc) => {
          const transactionID = doc.id;
          const itemsDocs = (
            await fireStore
              .collection('transactions-items')
              .where('transactionID', '==', transactionID)
              .get()
          ).docs;
          const fullItemsDataPromise = await itemsDocs.map(async (item) => {
            const { sellerID, clientID, productID } = item.data();
            const sellerData = (await fireStore.collection('usuarios').doc(sellerID).get()).data();
            const clientData = (await fireStore.collection('usuarios').doc(clientID).get()).data();
            const productData = (
              await fireStore.collection('produtos').doc(productID).get()
            ).data();

            return {
              id: item.id,
              ...item.data(),
              seller: { id: sellerID, data: sellerData },
              client: { id: clientID, data: clientData },
              product: { id: productID, data: productData }
            };
          });
          const items = await Promise.all(fullItemsDataPromise);
          return {
            id: transactionID,
            ...doc.data(),
            items
          };
        });
        const transactions = await Promise.all(transactionPromises);
        setTransactionsList(transactions);
      });
  }, []);

  return (
    <S.Container>
      <Header />
      <MainContent>
        <S.Content>
          <form>
            <input
              type="text"
              value={search}
              placeholder="Estou procurando por..."
              onChange={(e) => setSearch(e.target.value)}
            />
            <Link to={searchPath}>
              <Btnsearch type="submit" title="Encontrar" href={searchPath} />
            </Link>
          </form>
        </S.Content>
        <div className="table-title-container">
          <h1>Transações</h1>
        </div>
        <S.TableContainer>
          {transactionsList.map((charge) => (
            <ChargeAdmin key={charge.id} charge={charge} />
          ))}
        </S.TableContainer>
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default AdminTransactions;
